import { createAction } from 'redux-act';

import * as placements from '../../core/placements';

export const fetchPlacements = createAction(
  'get all placements',
);

export const fetchPlacementsSuccess = createAction(
  'get all placements success',
);

export const fetchPlacementsFail = createAction(
  'get all placements fail',
);

export const openEditPlacement = createAction(
  'open edit placement modal',
);
export const closeEditPlacement = createAction(
  'close edit placement modal',
);

export const updatePlacement = createAction(
  'update placement',
);

export const updatePlacementSuccess = createAction(
  'update placement success',
);

export const updatePlacementFail = createAction(
  'update placement fail',
  (error) => error
);

export const reducer = {
  [fetchPlacements]: (state, payload) =>
    placements.fetchPlacements(state, payload),
  [fetchPlacementsSuccess]: (state, payload) =>
   placements.fetchPlacementsSuccess(state, payload),

  [updatePlacementSuccess]: (state, payload) =>
    placements.updatePlacementSuccess(state, payload),

  [openEditPlacement]: (state, payload) =>
    placements.openEditPlacement(state, payload),
  [closeEditPlacement]: (state, payload) =>
    placements.closeEditPlacement(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/placements.module.js
 **/